import { VALID_SYSTEMS_DEAD_END_REASONS } from 'data/dead-end-constants';
import { ValidSystemsDeadEndReasonType } from 'types/dead-end';

// Whether a reason code from the API is one this build knows. The response
// is read through a cast, not parsed, so a code newer than this build is
// normalized where the diagnosis is stored (systems-slice
// setDeadEndForConfig) — with this guard, not with the copy table.
export const isDeadEndReason = (
  value: string
): value is ValidSystemsDeadEndReasonType =>
  (VALID_SYSTEMS_DEAD_END_REASONS as readonly string[]).includes(value);
